<script lang="ts">
    import type { ClassValue, SvelteHTMLElements } from 'svelte/elements'
    import {
        DesignKitIconSizes,
        type DesignKitIconSize,
        type IconGraphic
    } from '../foundations/iconography.js'

    type SvgAttributes = Omit<
        SvelteHTMLElements['svg'],
        | 'aria-hidden'
        | 'aria-label'
        | 'children'
        | 'class'
        | 'focusable'
        | 'height'
        | 'role'
        | 'viewBox'
        | 'width'
        | 'xmlns'
    >

    export type IconProps = SvgAttributes & {
        ariaLabel?: string
        class?: ClassValue
        color?: string
        graphic: IconGraphic
        size?: DesignKitIconSize
        style?: string
    }

    let {
        ariaLabel,
        class: className,
        color,
        graphic: GraphicComponent,
        size = 'm',
        style,
        ...svgAttributes
    }: IconProps = $props()

    const pixelSize = $derived(DesignKitIconSizes[size])
    const isDecorative = $derived(ariaLabel ? undefined : true)
    const role = $derived(ariaLabel ? 'img' : undefined)
    const colorStyle = $derived(
        color ? `--fill-0: ${color}; --stroke-0: ${color}; color: ${color};` : undefined
    )
    const consumerStyle = $derived(style ? `${style.trim().replace(/;?$/, '')};` : undefined)
    const resolvedStyle = $derived([consumerStyle, colorStyle].filter(Boolean).join(' ') || undefined)
</script>

<GraphicComponent
    {...svgAttributes}
    aria-hidden={isDecorative}
    aria-label={ariaLabel}
    class={['block shrink-0 overflow-visible', className]}
    focusable="false"
    height={pixelSize}
    {role}
    style={resolvedStyle}
    width={pixelSize}
/>
